import { render, staticRenderFns } from "./secPay.vue?vue&type=template&id=6a3699e2&scoped=true&"
import script from "./secPay.vue?vue&type=script&lang=js&"
export * from "./secPay.vue?vue&type=script&lang=js&"
import style0 from "./secPay.vue?vue&type=style&index=0&id=6a3699e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3699e2",
  null
  
)

export default component.exports